import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSZ: CultureInfo = {
  name: 'en-SZ',
  displayName: 'English (Eswatini)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SZ',
  parent: CultureInfoEn
};
